import redirect from './redirect';
import routes from '../constants/routes';
import routing from '../services/routing';

interface ISession {
    challengeName?: string;
    username: string;
    redirect_uri?: string;
}

export default (session: ISession) => {
    if (session.redirect_uri !== undefined) {
        redirect(session);
    } else if (session.challengeName !== undefined) {
        switch (session.challengeName) {
            case 'SMS_MFA':
                routing.push(routes.CONFIRM_SIGN_IN);
                break;
            case 'SOFTWARE_TOKEN_MFA':
                routing.push(routes.CONFIRM_SIGN_IN);
                break;
            case 'NEW_PASSWORD_REQUIRED':
                routing.push(routes.RESET_PASSWORD);
                break;
            case 'RESET_REQUIRED':
                routing.push(routes.CONFIRM_FORGOT_PASSWORD, {
                    username: session.username,
                });
                break;

            case 'MFA_SETUP':
                routing.push(routes.SETUP_MFA);
                break;
            default:
                throw new Error('INVALID_CHALLENGE');
        }
    } else {
        throw new Error('INVALID_RESPONSE');
    }
};
